<template>
    <div class="alternative-mechanics__name truncate-text">
        {{ toSentenceCase(params.data.title) }}
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { toSentenceCase } from '@/js/utils/string-utils';

export default defineComponent({
    methods: {
        toSentenceCase,
    },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
.flex-row {
    display: flex;
    flex-direction: row !important;
}

.alternative-mechanics__name {
    margin-left: 1rem;
}
</style>
